<template>
  <NewStudioModalsStartDesigningModal v-if="visible(ModalType.New)" @close="close(ModalType.New)" />
  <NewStudioModalsLoginModal v-if="visible(ModalType.Login)" @close="close(ModalType.Login)" />
  <NewStudioModalsSaveDesignModal v-if="visible(ModalType.SaveAs)" @close="close(ModalType.SaveAs)" />
  <NewStudioModalsSaveYourDesignModal v-if="visible(ModalType.SaveDesign)" @close="close(ModalType.SaveDesign)" />
  <NewStudioModalsLoadDesignModal v-if="visible(ModalType.Load)" @close="close(ModalType.Load)" />
  <NewStudioModalsYourDesignsModal v-if="visible(ModalType.MyDesigns)" @close="close(ModalType.MyDesigns)" />
  <NewStudioModalsShareDesignModal v-if="visible(ModalType.Share)" @close="close(ModalType.Share)" />
  <NewStudioModalsSystemModal v-if="systemType" :type="systemType" />
  <NewStudioModalsViewInRoomModal
    v-if="arOpen"
    :ar-page-url="arPageUrl"
    :model-url="arModelUrl"
    :loading="arLoading"
    :error="arError"
    :auto-launch="arAutoLaunch"
    @close="$emit('closeAr')"
    @retry="$emit('retryAr')"
  />
</template>

<script setup lang="ts">
import { ModalType } from '~/stores/modal'
defineProps<{ arOpen: boolean; arModelUrl: string | null; arPageUrl: string | null; arLoading: boolean; arError: string | null; arAutoLaunch: boolean }>()
defineEmits<{ closeAr: []; retryAr: [] }>()
const modalStore = useModalStore()
const visible = (type: ModalType) => modalStore.modals[type]?.visible
const close = (type: ModalType) => modalStore.toggleModal(type)
const systemTypes = [ModalType.MyTiles, ModalType.AttachmentOption, ModalType.ColorRemap, ModalType.File]
const systemType = computed(() => systemTypes.find((type) => visible(type)) || null)
</script>
